// Consolidated content parsing utilities for LandingPage
// This handles the new consolidated content structure

export const parseConsolidatedContent = (sections) => {
  const content = {};
  
  sections.forEach(section => {
    const parts = section.content.split('|');
    
    switch (section.section_key) {
      case 'hero_section':
        content.hero_title = parts[0] || '';
        content.hero_subtitle = parts[1] || '';
        break;
        
      case 'mission_section':
        content.mission_title = parts[0] || '';
        content.mission_description = parts[1] || '';
        break;
        
      case 'analysis_framework':
        content.analysis_framework_title = parts[0] || '';
        content.analysis_framework_description = parts[1] || '';
        content.framework_section_title = parts[2] || '';
        content.framework_tested_text = parts[3] || '';
        content.framework_modal_title = parts[2] || ''; // Same as section title
        content.framework_description_modal = parts[3] || '';
        break;
        
      case 'workflow_process':
        content.workflow_section_title = parts[0] || '';
        content.workflow_step_1_title = parts[1] || '';
        content.workflow_step_1_description = parts[2] || '';
        content.workflow_step_2_title = parts[3] || '';
        content.workflow_step_2_description = parts[4] || '';
        content.workflow_step_3_title = parts[5] || '';
        content.workflow_step_3_description = parts[6] || '';
        content.workflow_step_4_title = parts[7] || '';
        content.workflow_step_4_description = parts[8] || '';
        content.workflow_step_5_title = parts[9] || '';
        content.workflow_step_5_description = parts[10] || '';
        break;
        
      case 'custom_solutions':
        content.custom_solution_title = parts[0] || '';
        content.custom_solution_subtitle = parts[1] || '';
        content.solution_step_1_title = parts[2] || '';
        content.solution_step_1_description = parts[3] || '';
        content.solution_step_1_details = parts[4] ? parts[4].replace(/~/g, '|') : '';
        content.solution_step_2_title = parts[5] || '';
        content.solution_step_2_description = parts[6] || '';
        content.solution_step_2_details = parts[7] ? parts[7].replace(/~/g, '|') : '';
        content.solution_step_3_title = parts[8] || '';
        content.solution_step_3_description = parts[9] || '';
        content.solution_step_3_details = parts[10] ? parts[10].replace(/~/g, '|') : '';
        content.solution_step_4_title = parts[11] || '';
        content.solution_step_4_description = parts[12] || '';
        content.solution_step_4_details = parts[13] ? parts[13].replace(/~/g, '|') : '';
        content.solution_step_5_title = parts[14] || '';
        content.solution_step_5_description = parts[15] || '';
        content.solution_step_5_details = parts[16] ? parts[16].replace(/~/g, '|') : '';
        break;
        
      case 'analysis_levels':
        content.analysis_level_1_title = parts[0] || '';
        content.analysis_level_1_description = parts[1] || '';
        content.analysis_level_2_title = parts[2] || '';
        content.analysis_level_2_description = parts[3] || '';
        content.analysis_level_3_title = parts[4] || '';
        content.analysis_level_3_description = parts[5] || '';
        content.analysis_level_4_title = parts[6] || '';
        content.analysis_level_4_description = parts[7] || '';
        content.analysis_level_5_title = parts[8] || '';
        content.analysis_level_5_description = parts[9] || '';
        break;
        
      case 'services_pricing':
        content.services_pricing_title = parts[0] || '';
        content.services_pricing_subtitle = parts[1] || '';
        content.pricing_column_title = parts[2] || '';
        content.pricing_plan_1 = parts[3] ? parts[3].replace(/~/g, '|') : '';
        content.pricing_plan_2 = parts[4] ? parts[4].replace(/~/g, '|') : '';
        content.pricing_plan_3 = parts[5] ? parts[5].replace(/~/g, '|') : '';
        content.pricing_plan_4 = parts[6] ? parts[6].replace(/~/g, '|') : '';
        content.included_features = parts[7] ? parts[7].replace(/~/g, '|') : '';
        content.pricing_text = parts[8] || '';
        content.contact_button_text = parts[9] || '';
        break;
        
      case 'dashboard_preview':
        content.dashboard_preview_description = parts[0] || '';
        break;
        
      case 'customization_section':
        content.customization_title = parts[0] || '';
        content.customization_description = parts[1] || '';
        content.customization_conclusion = parts[2] || '';
        break;
        
      case 'team_section':
        content.team_title = parts[0] || '';
        content.team_description = parts[1] || '';
        
        // Parse team members (Patrice, Yves, Matthew)
        if (parts[2]) {
          content.patrice_name = parts[2];
          content.patrice_skills = parts[3] ? parts[3].replace(/~/g, '|') : '';
          content.patrice_bio = parts[4] || '';
          content.patrice_email = parts[5] || '';
          content.patrice_linkedin = parts[6] || '';
        }
        if (parts[7]) {
          content.yves_name = parts[7];
          content.yves_skills = parts[8] ? parts[8].replace(/~/g, '|') : '';
          content.yves_bio = parts[9] || '';
          content.yves_email = parts[10] || '';
          content.yves_linkedin = parts[11] || '';
        }
        if (parts[12]) {
          content.matthew_name = parts[12];
          content.matthew_skills = parts[13] ? parts[13].replace(/~/g, '|') : '';
          content.matthew_bio = parts[14] || '';
          content.matthew_email = parts[15] || '';
          content.matthew_linkedin = parts[16] || '';
        }
        break;
        
      case 'contact_section':
        content.contact_title = parts[0] || '';
        content.contact_description = parts[1] || '';
        content.contact_email = parts[2] || '';
        content.contact_email_label = parts[3] || '';
        content.contact_address = parts[4] || '';
        content.contact_address_label = parts[5] || '';
        break;
        
      case 'meta_content':
        content.logo_alt_text = parts[0] || '';
        content.framework_diagram_alt = parts[1] || '';
        content.patrice_alt_text = parts[2] || '';
        content.yves_alt_text = parts[3] || '';
        content.matthew_alt_text = parts[4] || '';
        content.detailed_framework_alt = parts[5] || '';
        break;
    }
  });
  
  return content;
};

export const defaultContent = {
  // Hero Section
  hero_title: 'Streamline crisis monitoring and make analysis faster, save lives',
  hero_subtitle: 'Real-time data collection, advanced analytics, and AI-powered humanitarian analysis — all in one secure platform.',
  
  // Mission Section
  mission_title: 'Streamline Your Crisis Monitoring with the Situation Room',
  mission_description: 'Emergencies flood analysts with spreadsheets, news feeds, and chat threads — slowing teams down and scattering focus. The Situation Room simplifies and accelerates the process by streamlining data collection, organization, and analysis so you can understand, anticipate, plan, and allocate resources faster during humanitarian crises.',
  
  // Analysis Framework
  analysis_framework_title: 'Comprehensive and in depth analysis of all humanitarian pillars',
  analysis_framework_description: 'Our analysis Framework covers both the operational environment (Context, Shocks, Displacement, Information & Communication, Humanitarian Access) and humanitarian conditions in key sectors (WASH, Food Security, Shelter, Livelihoods, health, logistics and more). Each pillar analysis is structured around five levels:',
  framework_section_title: 'Our humanitarian analysis framework',
  framework_tested_text: 'The framework has been tested and refined over a ten years period and was used in multiple crises by multiple NGOs or initiatives, e.g, DFS, NRC, SI, PAH, OP, OA, iMMAP Inc., DEEP, IFRC, etc.',
  framework_modal_title: 'Our humanitarian analysis framework',
  framework_description_modal: 'The framework has been tested and refined over a ten years period and was used in multiple crises by multiple NGOs or initiatives, e.g, DFS, NRC, SI, PAH, OP, OA, iMMAP Inc., DEEP, IFRC, etc.',
  
  // Workflow Process
  workflow_section_title: 'The situation room analysis workflow',
  workflow_step_1_title: 'Designed for credible, high-quality humanitarian analysis.',
  workflow_step_1_description: 'The Situation Room applies a custom humanitarian analysis framework (see below) covering all sectors, adapted to both sudden-onset and protracted crises. It follows a structured analysis plan and incorporates structured analytical techniques to reduce bias,follows humanitarian analysis standards, and aligns with decision-making needs.',
  workflow_step_2_title: 'Automated, continuous, and structured data collection',
  workflow_step_2_description: 'The Situation Room continuously collects and organizes online humanitarian information from trusted sources. It ensures access to relevant, timely, and unbiased data by applying sector-specific taxonomies across all content. The platform safeguards data integrity, eliminates basic errors, and systematically stores information - ensuring the evidence base is reliable, sufficient, and ready for analysis.',
  workflow_step_3_title: 'Assessing, structuring, and preparing evidence for use',
  workflow_step_3_description: 'The Situation Room transforms collected content into a structured, analysis-ready format. It filters and organizes information based on relevance and reliability, helping users distinguish credible data from noise. The platform assesses whether available evidence supports the analysis objectives and highlights key information gaps—geographic, thematic, or population-related.',
  workflow_step_4_title: 'Bridging facts, causes, meaning, foresight, and response.',
  workflow_step_4_description: 'The Situation Room supports all levels of humanitarian analysis. It enables descriptive analysis to summarize what is happening, explanatory analysis to uncover drivers and causal links, and interpretation to extract meaning and highlight significant findings. Anticipatory modules forecast future developments, while prescriptive analysis transforms insights into actionable recommendations.',
  workflow_step_5_title: 'Relevant, transparent, and decision-focused online situation room',
  workflow_step_5_description: 'The Situation Room generates structured outputs tailored to humanitarian decision-makers. Products include maps, indicator summary tables, charts, key event timelines, and problem trees - designed to answer priority questions clearly and effectively. Each output includes confidence ratings, highlights data limitations, and presents key findings to support transparent, informed decision-making.',
  
  // Team members
  patrice_name: 'Patrice Chataigner',
  patrice_skills: 'Project Lead|Strategic Foresight|Thematic Expert|Lead Analyst',
  patrice_bio: 'Patrice Chataigner is a senior humanitarian analyst and strategist with over 25 years of experience leading emergency response, crisis assessments, risk analysis, and digital innovation across more than 40 countries.',
  patrice_email: 'patrice@situation-room.ai',
  patrice_linkedin: 'https://www.linkedin.com/in/patrice-chataigner-819957254/',
  
  yves_name: 'Yves Kim Créac\'h',
  yves_skills: 'Humanitarian Strategist|Thematic Expert|Information Manager|Documentation Lead|QA Coordinator|AI-Enhanced Delivery',
  yves_bio: 'Yves-Kim Créac\'h is a seasoned humanitarian strategist with over 15 years of experience designing and implementing evidence-based solutions in complex emergency and resilience contexts.',
  yves_email: 'ykcreach@situation-room.ai',
  yves_linkedin: 'https://www.linkedin.com/in/yveskimcreach/',
  
  matthew_name: 'Matthew Lukin Smawfield',
  matthew_skills: 'Lead Developer|AI Engineering|Technical Architect|Data Visualization|UI/UX Designer',
  matthew_bio: 'Matthew Lukin Smawfield is a full-stack developer and humanitarian technology specialist with over 15 years of experience delivering critical information systems for major humanitarian organizations.',
  matthew_email: 'matthew@situation-room.ai',
  matthew_linkedin: '',
  
  // Contact
  contact_title: 'Contact us',
  contact_description: 'Situation Room is a project managed by Okular-Analytics and the Operations Partnership.',
  contact_email: 'team@situation-room.ai',
  contact_email_label: 'Email',
  contact_address: '12 Rue de chantepoulet\n1201 Geneva, Switzerland',
  contact_address_label: 'Address',
  
  // Other sections
  team_title: 'Our team',
  team_description: 'We are a collective of humanitarian analysts, AI specialists and data engineers with a single mission: To deliver transparent and actionable information to emergency responders.',
  customization_title: 'Whether you\'re tracking market trends, assessing program performance, monitoring risks, or producing strategic insights, we can help you design a Situation Room fully customized to your context.',
  customization_description: 'Our team works with clients to configure a dedicated, automated, and structured analysis environment that reflects your logic, priorities, and workflows. From data collection to reporting, every component is tailored to support your specific objectives, audience, and operational reality.',
  customization_conclusion: 'Let us help you build a Situation Room that delivers fast, credible, and actionable insights—exactly the way you need them.',
  dashboard_preview_description: 'Explore our live situation rooms featuring real-time data and AI-driven analysis. See how we monitor context, shocks, displacement, humanitarian access, impact and conditions in one unified view.',
  services_pricing_title: 'Services & Pricing',
  services_pricing_subtitle: 'Choose the service that fits your needs and see transparent pricing',
  pricing_column_title: 'Pricing',
  pricing_text: 'Contact us to discuss your plans, deadlines and requirements, we\'ll quote accordingly.',
  contact_button_text: 'Contact Us Today'
};